/**
 * Labstep
 *
 * @module components/Entity/Link
 * @desc Link to an entity show page
 */

import { fieldEntityName } from 'labstep-web/components/Entity/Form/fields';
import { EntityLinkComponent } from 'labstep-web/components/Entity/Link/Component';
import { FormShowEditLink } from 'labstep-web/core/Form/ShowEdit/Link';
import { Link } from 'labstep-web/core/Link';
import type { IRouting } from 'labstep-web/services/navigation.types';
import React from 'react';
import type { EntityLinkProps } from './types';

export const EntityLink: RFC<EntityLinkProps> = ({
  dataCy,
  entity,
  editableName,
  showIcon,
  secondary,
  to,
  displayName,
  children,
  disabled,
  query,
  linkParams = () => ({}),
}) => {
  const link = (
    <Link
      dataCy={dataCy}
      to={to || (`${entity.entityName}_show` as keyof IRouting)}
      query={query}
      params={{ id: entity.idAttr, ...linkParams(entity) }}
      disabled={disabled}
    >
      {children || (
        <EntityLinkComponent
          secondary={secondary}
          showIcon={showIcon}
          displayName={displayName}
          entity={entity}
          disabled={disabled}
        />
      )}
    </Link>
  );

  if (editableName) {
    return (
      <FormShowEditLink
        dataCy={dataCy}
        link={link}
        entity={entity}
        field={fieldEntityName(entity.entityName)}
        value={entity.displayName}
        entityName={entity.entityName}
      />
    );
  }

  return link;
};
